<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-flex>
          <v-layout>
            <v-flex xs4>
              <!-- <div class="subtitle-2 mb-1">Select Region</div> -->
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="regions"
                v-model="selectedRegion"
                item-text="name"
                placeholder="Select Region"
                @change="selectRegion"
              >
              </v-select>
            </v-flex>

            <v-flex text-right>
              <v-btn @click="openNewPerkDialog" depressed color="primary">
                Create New Perk
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout justify-space-between class="mt-3">
            <v-flex xs4>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs3 text-right v-if="selectedRegion.name !== 'All'">
              <v-select
                hide-details
                outlined
                placeholder="Filter By Status"
                dense
                v-model="selectedState"
                @change="stateSelected"
                :items="[
                  'all',
                  'active',
                  'scheduled',
                  'updated',
                  'expired',
                  'deleted',
                ]"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="perks"
        :items-per-page="30"
        class="elevation-0"
        :search="search"
        no-data-text="No data available, Select a region to start"
      >
        <template v-slot:item.data.image="{ item }">
          <div style="min-width: 50px">
            <v-icon small v-if="item.data.image"> mdi-paperclip </v-icon>
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small class="mr-2" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
          <v-icon small @click="copyItem(item)"> mdi-content-copy </v-icon>
        </template>
        <template v-slot:item.scheduledAt="{ item }">
          <div>
            {{ iMoment(item.scheduledAt) }}
          </div>
        </template>
        <!-- <template v-slot:item.region="{ item }">
          <div>
            {{ item.region.name }}
          </div>
        </template> -->
        <template v-slot:item.createdAt="{ item }">
          <div>
            {{ iMoment(item.createdAt) }}
          </div>
        </template>
      </v-data-table>
    </v-card>
    <new-perk-dialog
      :selectedRegion="selectedRegion"
      :collection="collection"
      ref="newPerkDialog"
    />
    <edit-perk-dialog
      :selectedRegion="selectedRegion"
      :perkDetail="editedItem"
      :collection="collection"
      ref="editPerkDialog"
    />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NewPerkDialog from '../components/NewPerkDialog';
import EditPerkDialog from '../components/EditPerkDialog.vue';
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
export default {
  components: { NewPerkDialog, EditPerkDialog },
  data() {
    return {
      selectedRegion: {},
      collection: 'pipeline',
      selectedState: '',
      search: '',
      dialogDelete: false,
      itemToDelete: {},
      headers: [
        {
          text: 'Title',
          align: 'start',
          sortable: true,
          value: 'data.content',
        },
        { text: 'Photo', value: 'data.image' },
        // { text: "Font Family", value: "fontFamily" },
        // { text: "Font Name", value: "fontName" },
        { text: 'Placement', value: 'data.placement' },

        { text: 'Scheduled At', value: 'scheduledAt' },
        // { text: "Region", value: "region" },
        { text: 'State', value: 'state' },

        // { text: 'Created At', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      editedItem: {},
    };
  },
  computed: {
    ...mapState('$_content', ['perks']),
    ...mapState('$_home', ['regions']),
  },
  created() {
    // if (this.perks.length === 0) {
    //   this.getPerks({
    //     type: "perk",
    //     collection: "pipeline",

    //     mutation: "updatePerks",
    //   });
    // }
    if (this.regions.length === 0) {
      this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
    }
  },
  methods: {
    ...mapActions({
      getPerks: '$_content/getContent',
      getPerksByRegion: '$_content/getContentByRegion',
      getPerksByRegionByState: '$_content/getContentByRegionByState',
      deletePerk: '$_content/deleteContent',
      getRegions: '$_home/getContent',
    }),
    selectRegion() {
      console.log('selectedRegion: ', this.selectedRegion);
      console.log(this.selectedState);
      switch (this.selectedState) {
        case 'all':
          this.getPerksByRegion({
            type: 'perk',
            collection: this.collection,
            mutation: 'updatePerks',
            region: this.selectedRegion,
          });
          break;
        case 'active':
          this.getPerksByRegionByState({
            type: 'perk',
            collection: this.collection,
            mutation: 'updatePerks',
            region: this.selectedRegion,
            state: this.selectedState,
          });
          break;
        case '':
          if (this.selectedRegion.name !== 'All') {
            this.selectedState = 'active';
          }
          console.log('setting region: ', this.selectedState);
          this.getPerksByRegionByState({
            type: 'perk',
            collection: this.collection,
            mutation: 'updatePerks',
            region: this.selectedRegion,
            state: this.selectedState,
          });
          break;
        default:
          this.getPerksByRegionByState({
            type: 'perk',
            collection: this.collection,
            mutation: 'updatePerks',
            region: this.selectedRegion,
            state: this.selectedState,
          });
          break;
      }
    },

    stateSelected(state) {
      this.selectedState = state;
      if (Object.keys(this.selectedRegion).length === 0) {
        return;
      }

      if (this.selectedState == 'all') {
        this.getPerksByRegion({
          type: 'perk',
          collection: this.collection,
          mutation: 'updatePerks',
          region: this.selectedRegion,
        });
      } else {
        this.getPerksByRegionByState({
          type: 'perk',
          collection: this.collection,
          mutation: 'updatePerks',
          region: this.selectedRegion,
          state: this.selectedState,
        });
      }
    },

    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format('lll');
      } else {
        return 0;
      }
    },
    openNewPerkDialog() {
      this.$refs.newPerkDialog.toggleDialog();
    },
    editItem(item) {
      this.editedIndex = this.perks.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign({}, this.perks[this.editedIndex]);

      // console.log("Edited Item: ", this.editedItem);

      this.$refs.editPerkDialog.toggleDialog(this.editedItem);
    },
    searchArr(latitude, longitude, myArray) {
      for (var i = 0; i < myArray.length; i++) {
        if (
          myArray[i].latitude === latitude &&
          myArray[i].longitude === longitude
        ) {
          return myArray[i].name;
        }
      }
    },
    copyItem(item) {
      this.editedIndex = this.perks.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign({}, this.perks[this.editedIndex]);

      // console.log("Edited Item: ", this.editedItem);

      this.$refs.editPerkDialog.toggleDialog(this.editedItem, 'copy');
    },
    deleteItem(item) {
      this.editedIndex = this.perks.indexOf(item);
      this.itemToDelete = Object.assign({}, this.perks[this.editedIndex]);
      this.itemToDelete.state = 'deleted';
      this.dialogDelete = true;

      // console.log(item);
    },
    deleteItemConfirm() {
      // console.log("Deleting Item: ", this.itemToDelete);

      this.deletePerk({
        details: this.itemToDelete,
        collection: this.collection,
        type: 'Perk',
      }).then(() => {
        this.dialogDelete = false;
        this.getPerksByRegion({
          type: 'perk',
          collection: this.collection,
          mutation: 'updatePerks',
          region: this.selectedRegion,
        });
      });
    },
  },
};
</script>

<style></style>
